"use client";

import { StaticImport } from "next/dist/shared/lib/get-img-props";
import Image from "next/image";
import { Suspense, useRef, useState } from "react";
import { InView } from "react-intersection-observer";
import { ZoomInPartialOnScroll } from "@/components/effects/ZoomInPartialOnScroll";
import TextHeader from "@/components/typography/TextHeader";

export default function FullscreenVideoHero({
  children,
  image,
  imageDesktop,
  video,
  videoDesktop,
  loop = false,
}: React.PropsWithChildren<{
  children: React.ReactNode;
  image: string | StaticImport;
  imageDesktop: string | StaticImport;
  video?: string;
  videoDesktop?: string;
  loop?: boolean;
}>) {
  const [playing, setPlaying] = useState<boolean>(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const handleVideoPress = (inView: boolean) => {
    if (video) {
      if (inView && !playing) {
        videoRef.current?.play();
        setPlaying(true);
      } else {
        videoRef.current?.pause();
        setPlaying(false);
      }
    }
  };

  return (
    <InView onChange={handleVideoPress}>
      <ZoomInPartialOnScroll className="relative overflow-hidden rounded-lg">
        <Image
          src={image}
          alt={""}
          className="absolute inset-0 h-full w-full object-cover lg:hidden"
        />
        <Image
          src={imageDesktop}
          alt={""}
          className="absolute inset-0 hidden h-full w-full object-cover lg:block"
        />
        {video && (
          <Suspense>
            <video
              className={"absolute inset-0 h-full w-full object-cover"}
              muted
              playsInline
              ref={videoRef}
              loop={loop}
            >
              <source
                src={video}
                type="video/mp4"
                media="screen and (max-width: 768px)"
              />
              <source
                src={videoDesktop}
                type="video/mp4"
                media="screen and (min-width: 768px)"
              />
            </video>
          </Suspense>
        )}
        <div className="relative flex min-h-lvh lg:aspect-[2/1] lg:min-h-0">
          <div
            className={
              "absolute inset-x-0 top-0 z-10 flex h-2/5 w-full items-center justify-center bg-gradient-to-b from-black/50 to-transparent px-5"
            }
          >
            <div className="max-w-screen-md">
              <TextHeader className="!mb-0 text-center text-white">
                {children}
              </TextHeader>
            </div>
          </div>
        </div>
      </ZoomInPartialOnScroll>
    </InView>
  );
}
